// Force show delay: ?promoSocial
// Force show immediate: ?promoSocial=show

// DOM
const socialPopover = document.querySelector('[data-sg-promo-social]');
const closeButton = document.querySelector('[data-sg-promo-social-close]');

// Config 
const dismissedKey = 'popoverDismissed';
const dismissedExpiration = 24 * 60 * 60 * 1000; // 24h
const showDelay = 25 * 1000;

// State
let hasDom = false;

function showPopover() {
    // Prevent showing an inert popover on top of a modal dialog
    const hasOpenDialog = Boolean(document.querySelector('dialog[open]'));
    if (!hasOpenDialog) {
        socialPopover.showPopover();
        socialPopover.classList.remove('sg-is-initial');
        document.removeEventListener('dialogClosed', showPopoverOnDialogClose);
    // Show the popover on closing the modal dialog
    } else {
        document.addEventListener('dialogClosed', showPopoverOnDialogClose);
    }
}

function showPopoverOnDialogClose() {
    showPopover();
}

function dismissPopover() {
    socialPopover.hidePopover();
    socialPopover.classList.add('sg-is-initial');
    const dismissedUntil = Date.now() + dismissedExpiration;
    localStorage.setItem(dismissedKey, dismissedUntil.toString());
}

function isDismissed() {
    const dismissedUntil = localStorage.getItem(dismissedKey);
    if (!dismissedUntil) return false;
    return Date.now() < parseInt(dismissedUntil, 10);
}

function schedulePopover() {
    const urlParams = new URLSearchParams(window.location.search);
    const promoSocialValue = urlParams.get('promoSocial');
    const forceShow = promoSocialValue !== null; 
    const forceShowImmediate = promoSocialValue === 'show'; 

    if (isDismissed() && ! forceShow) return;

    if (forceShowImmediate) {
        showPopover();
    } else {
        setTimeout(() => showPopover(), showDelay);
    }
}

function upgrade() {
    socialPopover.popover = 'manual';    
    closeButton.addEventListener('click', dismissPopover);
}

function init() {
    hasDom = socialPopover && closeButton;
    if ( ! hasDom) return;

    upgrade();
    schedulePopover();
}

export default {
    init
}
